import { useLocalization } from '@/shared/composables/localization'

export const bytesConverter = (bytes: number | undefined) => {
  if (bytes === undefined) return 0

  const { t } = useLocalization()

  if (bytes < 1024) {
    return bytes + ` ${t('common.bytes')}`
  } else if (bytes < 1024 * 1024) {
    return (bytes / 1024).toFixed(2) + ` ${t('common.kb')}`
  } else if (bytes < 1024 * 1024 * 1024) {
    return (bytes / (1024 * 1024)).toFixed(2) + ` ${t('common.mb')}`
  } else {
    return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ` ${t('common.gb')}`
  }
}
